import { applyDueDateMetaToStringFilter, buildDueDateMetaFromMonth } from "@/ui/forms/DateMonthYearPicker.vue";

export const headerTable = [
    {
        field: "typeName",
        title: "Tipo",
        type: "class",
        fieldComparison: "typeName",
        classCssTitle: "text-center",
        classCssBody: [
            { classCss: "text-center badge badge-danger", fieldComparison: "Pagar" },
            { classCss: "text-center badge badge-primary", fieldComparison: "Receber" },
        ],
    },
    {
        title: "Vencimento",
        field: "dueDate",
        type: "text",
        iconSearch: true,
        classCssTitle: "text-center",
        classCssBody: "text-center",
    },
    {
        field: "recipientName",
        fieldSecond: "description",
        title: "Descrição",
        type: "link",
        eventName: "payableReceivableUpdate",
        iconSearch: true,
    },
    { field: "status", type: "html" },
    { field: "documents", type: "html", classCssBody: "text-center" },
    { field: "tags", type: "html", classCssBody: "text-center" },
    {
        title: "Valor",
        field: "value",
        type: "currency",
        classCssTitle: "text-center",
        classCssBody: "text-center",
    },
    {
        type: "button",
        typeButton: "dropdown",
        classCssBody: "text-center",
        styleBody: "width: 80px;",
        button: {
            title: "Mais...",
            type: "info",
            classIcon: "fa-solid fa-chevron-down",
            size: "small",
            items: [
                {
                    title: "Recibo",
                    classIcon: "fa-solid fa-file-invoice-dollar",
                    eventName: "receiptFinance",
                    hr: false,
                },
            ],
        },
    },
];

export const defaultPanel = {
    module: "Financeiro",
    title: "Pagar e Receber",
    showSearch: true,
    showButtons: true,
};

export const summaryDefaults = {
    prevBalance: 1500,
    totalPagar: 900,
    totalReceber: 600,
    balanceType: "positive",
};

export const payableReceivableFilters = [
    {
        type: "multiOptions",
        title: "Centro de Custo",
        field: "CostCenterName",
        url: "/api/v1/finance/cost-center/select-all",
        propsParams: {},
        value: "",
    },
    {
        type: "multiOptions",
        title: "Conta Bancária",
        field: "BankAccountName",
        url: "/api/v1/finance/bank-account/select-all",
        propsParams: {},
        value: "",
    },
    {
        type: "text",
        title: "Documento",
        field: "Document",
        value: "",
    },
    {
        type: "options",
        title: "Pagar ou Receber",
        field: "TypeName",
        options: [
            { text: "Pagar", value: "Pagar" },
            { text: "Receber", value: "Receber" },
        ],
        value: [],
    },
    {
        type: "multiOptions",
        title: "Plano de Conta",
        field: "ChartOfAccountsName",
        url: "/api/v1/finance/chart-of-accounts/select-all",
        propsParams: {},
        value: "",
    },
    {
        type: "options",
        title: "Pago/Recebido",
        field: "PaidName",
        options: [
            { text: "Sim", value: "Sim" },
            { text: "Não", value: "Não" },
        ],
        value: [],
    },
    {
        type: "options",
        title: "Status",
        field: "statusKey",
        options: [
            { text: "Agendada", value: "Agendada" },
            { text: "Pago", value: "Pago" },
            { text: "Recebido", value: "Recebido" },
            { text: "Pendente", value: "Pendente" },
        ],
        value: [],
    },
    {
        type: "multiOptions",
        title: "Tipo de Pagamento",
        field: "TypePaymentName",
        url: "/api/v1/finance/type-payment/select-all",
        propsParams: {},
        value: "",
    },
    {
        type: "decimal",
        title: "Valor",
        field: "Value",
        valueStart: 0,
        valueEnd: 0,
    },
];

export const payableReceivableConfigOptions = [
    { text: "Mostrar baixadas", value: "showClosed" },
    { text: "Mostrar saldo diário", value: "showBalance" },
    { text: "Mostrar resumo financeiro", value: "showSummary" },
    { text: "Vencimento (mais recente primeiro)", value: "sortDueDateDesc" },
];

export const payableReceivableConfigInitialValue = [
    "showBalance",
    "showSummary",
    "sortDueDateDesc",
];

export const payableReceivableConfigStorageKey = "payableReceivableListConfigOptions";

export const payableReceivableOrderByTitle = "OrderBy";
export const payableReceivableDueDateOrderField = "_DueDate";
export const payableReceivableDueDateTitle = "Data de Vencimento";

export function normalizePayableReceivableTitle(title) {
    return (title || "")
        .toString()
        .trim()
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/\s+/g, "-");
}

export function createPayableReceivableDefaultFilterState() {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth() + 1;
    const dueDateMeta = buildDueDateMetaFromMonth(year, month);

    return {
        scope: "picker",
        mode: "month",
        year,
        month,
        startDate: "",
        endDate: "",
        filterQueryModel: applyDueDateMetaToStringFilter({
            stringFilter: [],
            dueDateMeta,
            routeName: "",
            field: payableReceivableDueDateOrderField,
            title: payableReceivableDueDateTitle,
            type: "date",
        }),
    };
}

export function isPayableReceivableDueDateOrderByFilter(item) {
    return item?.field === payableReceivableDueDateOrderField && item?.title === payableReceivableOrderByTitle;
}

export function isPayableReceivableDueDateValueFilter(item) {
    return item?.field === payableReceivableDueDateOrderField && item?.title === payableReceivableDueDateTitle;
}

export function isPayableReceivableSearchFilter(item) {
    return item?.field === "Search";
}

export function isPayableReceivablePaidNameFilter(item) {
    return (item?.field || "").toString().toLowerCase() === "paidname";
}

export function hasPayableReceivableFilterValue(value) {
    if (Array.isArray(value)) {
        return value.length > 0;
    }

    if (value === null || value === undefined) {
        return false;
    }

    return value.toString().trim() !== "";
}

export function isReservedPayableReceivableFilter(item) {
    return isPayableReceivableDueDateOrderByFilter(item)
        || isPayableReceivableDueDateValueFilter(item)
        || isPayableReceivableSearchFilter(item);
}

export function getPayableReceivableConfigSelection() {
    try {
        const raw = localStorage.getItem(payableReceivableConfigStorageKey);
        if (!raw) {
            return [...payableReceivableConfigInitialValue];
        }

        const parsed = JSON.parse(raw);
        if (!Array.isArray(parsed)) {
            return [...payableReceivableConfigInitialValue];
        }

        const validValues = payableReceivableConfigOptions.map((option) => option.value);
        return parsed.filter((value) => validValues.includes(value));
    } catch {
        return [...payableReceivableConfigInitialValue];
    }
}

export function savePayableReceivableConfigSelection(selection) {
    const safeSelection = Array.isArray(selection) ? selection : [];
    localStorage.setItem(payableReceivableConfigStorageKey, JSON.stringify(safeSelection));
}

export function getPayableReceivableDueDateOrderValue(selection = getPayableReceivableConfigSelection()) {
    return Array.isArray(selection) && selection.includes("sortDueDateDesc") ? "desc" : "asc";
}

export function getPayableReceivableTypeCostCenter(type) {
    return type == 1 ? "2" : "1";
}

export function isPaidOrReceived(item) {
    const extractText = (html) => (html ? html.toString().trim() : "");

    const plainStatus = extractText(item?.status).toLowerCase();
    const paidName = (item?.paidName || "").toString().toLowerCase();
    const statusName = (item?.statusName || item?.statusText || item?.statusLabel || "").toString().toLowerCase();
    const statusTexts = [plainStatus, paidName, statusName];

    if (statusTexts.some((text) => text.includes("parcial"))) {
        return false;
    }

    const paidFlag = [item?.paid, item?.isPaid, item?.closed, item?.isClosed].some((value) => value === true);

    if (paidFlag) {
        return true;
    }

    return statusTexts.some((text) => text.includes("pago") || text.includes("recebido"));
}

export function hasExistingPartialPayment(item) {
    const extractText = (html) => (html ? html.toString().trim() : "");

    const plainStatus = extractText(item?.status).toLowerCase();
    const paidName = (item?.paidName || "").toString().toLowerCase();
    const statusName = (item?.statusName || item?.statusText || item?.statusLabel || "").toString().toLowerCase();
    const statusTexts = [plainStatus, paidName, statusName];

    return statusTexts.some((text) => text.includes("parcial"));
}
